"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Table.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableMethods = require("./TableMethods");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Table = _ref => {
  let {
    data,
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("table", {
    className: (0, _TableMethods.variantClass)(className)
  }, data.head && /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, (0, _TableMethods.generateHeadCells)(data))), /*#__PURE__*/_react.default.createElement("tbody", null, (0, _TableMethods.generateBody)(data)));
};
var _default = Table;
exports.default = _default;
Table.propTypes = {
  data: _propTypes.default.object.isRequired,
  className: _propTypes.default.string
};